// src/Pages/RedirectToApp.js
import React, { useEffect } from 'react';
import Layout from '../Components/Layout/Layout';

function RedirectToApp() {
  const handleDownloadApp = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    let url = '';

    if (/android/i.test(userAgent)) {
      url = 'https://play.google.com/store/apps/details?id=app.accon.pizzaprime&hl=pt';
      // url = 'https://pizzaprime.voceqpad.com.br';
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      url = 'https://apps.apple.com/br/app/pizza-prime-delivery/id1462955878';
    } else {
      url = 'https://pizzaprime.voceqpad.com.br'; // URL padrão para dispositivos web e outros
    }

    window.open(url, '_self');
  };

  useEffect(() => {
    handleDownloadApp();
  }, []);

  return (
    <Layout>
      <div className="page">
        <h1>Redirecionando...</h1>
        <p>Aguarde enquanto estamos direcionando você para o aplicativo.</p>
      </div>
    </Layout>
  );
}

export default RedirectToApp;
